import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';

import {
  Nav,
} from './layout';
import {
  RouteArticles,
  RouteSite,
  RouteAnnouncements,
  RouteCompetitions,
  RouteSchools,
  RouteReports,
  RouteUsers,
  RouteDashboards,
} from './routes';
import PageNotFound from '~/commons/components/PageNotFound.jsx';

import { env } from '~/commons/config';

const Admin = () => (
  <div className="container-fluid h-100 bg-lighter">
    <div className="row h-100">
      <Router basename={env.base}>
        <Nav />
        <div className="col">
          <div className="px-4">
            <Switch>
              <Route path="/admin" exact>
                <Redirect to={
                    env.user.roles.includes('admin')
                      ? '/admin/users/students'
                      : '/admin/dashboard'
                } />
              </Route>
              <Route path="/admin/dashboard">
                <RouteDashboards />
              </Route>
              <Route path="/admin/users">
                <RouteUsers />
              </Route>
              <Route path="/admin/schools">
                <RouteSchools />
              </Route>
              <Route path="/admin/articles">
                <RouteArticles />
              </Route>
              <Route path="/admin/competitions">
                <RouteCompetitions />
              </Route>
              <Route path="/admin/site">
                <RouteSite />
              </Route>
              <Route path="/admin/announcements">
                <RouteAnnouncements />
              </Route>
              <Route path="/admin/reports">
                <RouteReports />
              </Route>
              <Route path="*">
                <PageNotFound vAlign />
              </Route>
            </Switch>
          </div>
        </div>
      </Router>
    </div>
  </div>
);

export default Admin;
